export default __webpack_public_path__ + "static/immolation-5f4cdb316575dd7fb29b3b826d9a6437.jpg";